// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"cx_h4","tabListWrapper":"cx_h5","tabList":"cx_h6","tabItem":"cx_h7","tabContent":"cx_h8"};